import React from 'react';

const ProximitySensors = (props) => {

    let debug = false;

    return (
        <div className={'proximity ' + (debug ? 'debug' : '')}>
            <div className="center" onMouseEnter={() => props.handleProximitySensor(0)} onClick={() => props.handleHeadingClick()} />
            <div className="top-0" onMouseEnter={() => props.handleProximitySensor(0.5)} />
            <div className="top-1" onMouseEnter={() => props.handleProximitySensor(1)} />
            <div className="top-2" onMouseEnter={() => props.handleProximitySensor(2)} />
            <div className="right-0" onMouseEnter={() => props.handleProximitySensor(0.5)} />
            <div className="right-1" onMouseEnter={() => props.handleProximitySensor(1)} />
            <div className="right-2" onMouseEnter={() => props.handleProximitySensor(2)} />
            <div className="right-3" onMouseEnter={() => props.handleProximitySensor(3)} />
            <div className="bottom-0" onMouseEnter={() => props.handleProximitySensor(0.5)} />
            <div className="bottom-1" onMouseEnter={() => props.handleProximitySensor(1)} />
            <div className="bottom-2" onMouseEnter={() => props.handleProximitySensor(2)} />
        </div>
    );

};

export default ProximitySensors;


// WEBPACK FOOTER //
// ./src/js/components/ProximitySensors.js